<template>
  <div id="main-wrap">
    <WebTools />
    
    <Carousel v-model="bannerSlider" autoplay loop :autoplay-speed="7000">
      
      <CarouselItem v-for="(item, index) in banners" v-bind:key="index">
        <div class="banner-carousel-item" v-bind:style="{background: 'url('+item.picPath+') center 0 no-repeat', backgroundSize: 'auto 240px'}"><a target="_blank" class="banner-link" :href="item.link"></a></div>
      </CarouselItem>

    </Carousel>

    <!--web nav-->
    <CspaWebMenu />

    <div class="body-wrap">
      <!--row one-->
      <Row class="index-row-one">
        <Col class="index-row-one-left" span="16">
          <div class="block-title-wrap">
            <div class="block-title">协会新闻</div>
            <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 14, sid: website}}">更多》</router-link></div>
          </div>
          <div class="news-carousel-wrap">
            <Carousel v-model="newsSlider" autoplay loop :autoplay-speed="5000">
              <CarouselItem v-for="(item, index) in newsSliders" v-bind:key="index">
                <div class="news-carousel-item-wrap">
                  <a target="_blank" :href="item.link"><img class="news-carousel-item-img" :src="item.picPath" ></a>
                  <div class="news-carousel-item-title"><a :href="item.link" target="_blank">{{item.title}}</a></div>
                </div>
              </CarouselItem>
            </Carousel>
          </div>
        </Col>
        <Col class="index-row-one-right" span="8">
          <div class="block-title-wrap">
            <div class="block-title">基层动态</div>
            <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 5, sid: website}}">更多》</router-link></div>
          </div>
          <ul class="index-row-one-news">
            <!-- <li v-for="(item, index) in baseNews" v-bind:key="index">
              <a :href="item.link">{{item.title}}</a>
            </li> -->
            <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in baseNews" v-bind:key="index">
              <a target="_blank">{{item.title}}</a>
              <span>{{item.pubDate}}</span>
            </router-link>

          </ul>
        </Col>
      </Row>
      <!--row one end-->

      <!--row two-->
      <Row class="index-row-two">
        <Col class="index-row-two-left" span="16">
          <Row>
            <Col class="index-row-two-notice" span="12">
              <div class="block-title-wrap">
                <div class="block-title">通知公告</div>
                <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 8, sid: website}}">更多》</router-link></div>
              </div>
              <ul class="index-row-two-notice-list">
                <!-- <li v-for="(item, index) in noticesNews" v-bind:key="index">
                  <a href="/columns/show?id=152&amp;aid=1">{{item.title}}</a>
                  
                </li> -->
                <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in noticesNews" v-bind:key="index">
                  <a target="_blank">{{item.title}}</a>
                  <span class="index-row-two-time">{{item.pubDate}}</span>
                </router-link>
              </ul>
            </Col>
            <Col class="index-row-two-video" span="12">
              <div class="block-title-wrap">
                <div class="block-title">视频报道</div>
                <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 9, sid: website}}">更多》</router-link></div>
              </div>
              <Carousel v-model="videosSlider" autoplay loop :autoplay-speed="7000">
                
                <CarouselItem v-for="(item, index) in videos" v-bind:key="index">
                  <div class="videos-carousel-item-wrap">
                    <a target="_blank" :href="item.link"><img class="videos-carousel-item-img" :src="item.picPath" ></a>
                    <div class="videos-carousel-item-title"><a :href="item.link" target="_blank">{{item.title}}</a></div>
                  </div>
                </CarouselItem>
                
              </Carousel>
            </Col>
          </Row>
        </Col>
        <Col class="index-row-two-right" span="8">
          <div class="block-title-wrap">
            <div class="block-title">学习园地</div>
            <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 3, sid: website}}">更多》</router-link></div>
          </div>
          <!-- <ul class="index-row-two-study">
            <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in studiesNews" v-bind:key="index">
              <a target="_blank">{{item.title}}</a>
            </router-link>
          </ul> -->
          <Carousel v-model="studyNewsSliser" autoplay loop dots="none" arrow="hover" :autoplay-speed="8000">

                <CarouselItem v-for="(files, index) in studiesNews" v-bind:key="index">
                  <ul class="index-row-three-files-list">
                    <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in files" v-bind:key="index">
                      <a target="_blank">{{item.title}}</a>
                    </router-link>
                  </ul>
                </CarouselItem>

              </Carousel>
          </Col>
      </Row>
      <!--row two end-->

      <!--row three-->
      <Row class="index-row-three">
        <Col class="index-row-three-left" span="16">
          <Row>
            <Col class="index-row-three-files" span="12">
              <div class="block-title-wrap">
                <div class="block-title">协会文件</div>
                <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 13, sid: website}}">更多》</router-link></div>
              </div>
              <!-- <ul class="index-row-three-files-list">
                <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in fieldsNews" v-bind:key="index">
                  <a target="_blank">{{item.title}}</a>
                </router-link>
              </ul> -->
              <Carousel v-model="fieldsNewsSliser" autoplay loop dots="none" arrow="hover" :autoplay-speed="8000">

                <CarouselItem v-for="(files, index) in fieldsNews" v-bind:key="index">
                  <ul class="index-row-three-files-list">
                    <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in files" v-bind:key="index">
                      <a target="_blank">{{item.title}}</a>
                    </router-link>
                  </ul>
                </CarouselItem>

              </Carousel>
            </Col>
            <Col class="index-row-three-health" span="12">
              <div class="block-title-wrap">
                <div class="block-title">健康养生</div>
                <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 6, sid: website}}">更多》</router-link></div>
              </div>
              <ul class="index-row-three-health-list">
                <!-- <li v-for="(item, index) in healthNews" v-bind:key="index">
                  <a href="/columns/show?id=136&amp;aid=1">{{item.title}}</a>
                </li> -->
                <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in healthNews" v-bind:key="index">
                  <a target="_blank">{{item.title}}</a>
                  <span class="index-row-three-time">{{item.pubDate}}</span>
                </router-link>
              </ul>
            </Col>
          </Row>
        </Col>
        <Col class="index-row-three-right" span="8">
          <div class="block-title-wrap">
            <div class="block-title">多彩人生</div>
            <div class="block-more"><router-link :to="{path: '/columns/list', query: {colid: 32, sid: website}}">更多》</router-link></div>
          </div>
          <div class="index-row-three-color-img"><a :href="colors.link" target="_blank"><img :src="colors.picPath"></a></div>
          <ul class="index-row-three-color">
            <!-- <li v-for="(item, index) in colorsNews" v-bind:key="index">
              <a href="/columns/show?id=136&amp;aid=1">{{item.title}}</a>
            </li> -->
            <router-link tag="li" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" v-for="(item, index) in colorsNews" v-bind:key="index">
              <a target="_blank">{{item.title}}</a>
            </router-link>
          </ul>
        </Col>
      </Row>
      <!--row three end-->
      
      <!--association-->
      <div class="association-sub-wrap">
        <div class="association-sub-title-wrap">
          <div class="association-sub-title-content"><i>省市自治区老教授协会</i></div>
        </div>
        <ul class="sub-association-list">
          <li v-for="(item, index) in provinceLevel" v-bind:key="index">
            <a v-if="item.website!=''" :href="item.website" target="_blank">{{item.assoName}}</a>
            <router-link v-else-if="item.isOpened==1" :to="{path: '/', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
            <router-link v-else :to="{path: '/subassociation', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
          </li>
        </ul>
      </div>
      <!--association end-->

      <!--association-->
      <div class="association-sub-wrap">
        <div class="association-sub-title-wrap">
          <div class="association-sub-title-content"><i>分支机构及附属机构</i></div>
        </div>
        <ul class="sub-association-list">
          <li v-for="(item, index) in subsLevel" v-bind:key="index">
            <!-- <a href="http://www.chinagaizao.com" target="_blank">{{item.assoName}}</a> -->
            <a v-if="item.website!=''" :href="item.website" target="_blank">{{item.assoName}}</a>
            <router-link v-else-if="item.isOpened==1" :to="{path: '/', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
            <router-link v-else :to="{path: '/subassociation', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
          </li>
        </ul>
      </div>
      <!--association end-->

      <!--association-->
      <div class="association-sub-wrap">
        <div class="association-sub-title-wrap">
          <div class="association-sub-title-content"><i>高校及科研机构老教授协会</i></div>
        </div>
        <ul class="sub-association-list">
          <li v-for="(item, index) in schoolsLevel" v-bind:key="index">
            <!-- <a href="http://www.chinagaizao.com" target="_blank">{{item.assoName}}</a> -->
            <a v-if="item.website!=''" :href="item.website" target="_blank">{{item.assoName}}</a>
            <router-link v-else-if="item.isOpened==1" :to="{path: '/', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
            <router-link v-else :to="{path: '/subassociation', query:{sid: item.assoId}}" target="_blank">{{item.assoName}}</router-link>
          </li>
        </ul>
      </div>
      <!--association end-->
    </div>
    
    <CspaWebFooter />
  </div>
</template>

<script>
import axios from "axios"
import WebTools from "@/components/WebTools.vue"
import CspaWebMenu from "@/components/CspaWebMenu.vue"
import CspaWebFooter from "@/components/CspaWebFooter.vue"
export default {
  name: 'Home',
  components: {
    WebTools,
    CspaWebMenu,
    CspaWebFooter
  },

  data() {
    return {
      website: 0,
      bannerSlider: 0,
      newsSlider: 0,
      videosSlider: 0,
      fieldsNewsSliser: 0,
      studyNewsSliser: 0,
      banners: [],
      newsSliders: [],
      videos: [],
      //多彩人生只需一条
      colors: {},
      baseNews: [],
      colorsNews: [],
      fieldsNews: [],
      healthNews: [],
      noticesNews: [],
      studiesNews: [],
      subsLevel: [],
      provinceLevel: [],
      schoolsLevel: [],
    }
  },

  //页面加载完成执行
  mounted() {
    this.initPageData()

    this.initIndexSliders()
    this.initIndexNews()
    this.initIndexAssociations()
  },

  //页面方法
  methods: {
    //初始化页面数据
    initPageData() {
      let sid = parseInt(this.$route.query.sid)
      if(!isNaN(sid) && sid>1) {
        this.website = sid
      } else {
        this.website = 0
      }
    },

    //初始化页面图片数据
    initIndexSliders() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/index/home-sliders",
        {site: vm.website, status: 1},
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          vm.banners = res.data.data.banners
          vm.newsSliders = res.data.data.news
          vm.videos = res.data.data.videos
          vm.colors = res.data.data.colors
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //初始化页面新闻数据
    initIndexNews() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/index/home-news",
        {site: vm.website, status: 1},
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          let gotted = res.data.data
          vm.baseNews = gotted.baseNews
          vm.colorsNews = gotted.colors
          vm.fieldsNews = [gotted.fields.slice(0,7), gotted.fields.slice(7,)]
          vm.healthNews = gotted.health
          vm.noticesNews = gotted.notices
          vm.studiesNews = [gotted.studies.slice(0,7), gotted.studies.slice(7,)]
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //初始化机构数据
    initIndexAssociations() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/index/home-associations",
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          let gotted = res.data.data
          vm.subsLevel = gotted.subsLevel
          vm.provinceLevel = gotted.provinceLevel
          vm.schoolsLevel = gotted.schoolsLevel
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

  }
}
</script>
